const userMenu = {
  'userMenu.english': 'English',
  'userMenu.portuguese': 'Portuguese',
  'userMenu.spanish': 'Spanish',
  'userMenu.notifications': 'Notifications',
  'userMenu.help': 'Help',
  'userMenu.exit': 'Log out',
  'userMenu.profile': 'Profile',
  'userMenu.language': 'Language',
};

export default userMenu;
